import { useState } from 'react';

import AddRoundedIcon from '@mui/icons-material/AddRounded';
import {
    Box,
    Accordion,
    Container,
    Typography,
    AccordionSummary,
    AccordionDetails,
    ListItem,
    Stack,
} from '@mui/material';



const faqs = [
    {
        question: 'What is Hamsa Lomi?',
        answer: 'Hamsa Lomi is a 501(c)(12) association that provides financial support to members during the loss of a family member.'
    },
    {
        question: 'Who is eligible to join Hamsa Lomi?',
        answer: 'Anyone who lives within a 60-mile radius of Nashville, TN, can become a member during the designated registration periods.'
    },
    {
        question: 'When can new members register?',
        answer: 'New members can join twice a year, in February and October.'
    },
    {
        question: 'What are the qualifications required to become a member of the Hamsa Lomi Ethiopian Association?',
        answer:
            'To become a member of the Hamsa Lomi Ethiopian Association, individuals must meet the following criteria:',
        listItems: [
            'Be at least 18 years old.',
            'Reside in Nashville, Tennessee, or nearby cities',
            'Agree to abide by the association\'s bylaws and any additional requirements for individual membership as may be imposed by the General Assembly from time to time.'
        ]
    },
    {
        question: 'How can a member be removed from the Hamsa Lomi Ethiopian Association?',
        answer: 'Membership can be terminated for valid reasons, including failure to pay membership dues within 60 days without a valid explanation, permanently relocating outside the Nashville area, or engaging in actions that jeopardize the association\'s existence.'
    },



    {
        question: 'What is the registration fee for new members?',
        answer: 'New members must pay a $300 registration fee upon joining.'
    },
    {
        question: 'Is there a waiting period before new members receive benefits?',
        answer: 'Yes, new members must complete a six-month waiting period before becoming eligible for benefits.'
    },
    {
        question: 'How does Hamsa Lomi communicate with its members?',
        answer: 'The association communicates via text messages and email for important updates and notifications.'
    },
    {
        question: 'How do members contribute financially?',
        answer: 'Contributions are not collected monthly. Instead, when a member passes away, all members contribute an allocated amount to support the deceased’s family.'
    },
    {
        question: 'What financial benefit do families receive when a member passes away?',
        answer: 'The family of a deceased member receives $20,000 from Hamsa Lomi.'
    },
    {
        question: 'When do members need to make their contributions?',
        answer: 'Members must make the required contribution within seven days of receiving the invoice. If payment is not made within that time, a $20 penalty fee applies.'
    }
];


function FAQSection() {

    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <Container maxWidth="wrapper" sx={{ my: 3 }}>
            <Typography
                variant="h4"
                fontWeight="bold"
                textAlign="center"
                gutterBottom
                color="rgba(26,128,200)"

            >
                Frequently Asked Questions

            </Typography>

            <Box sx={{ width: '100%' }}>
                {faqs.map((faq, index) => (
                    <Accordion
                        key={index}
                        expanded={expanded === `panel${index}`}
                        onChange={handleChange(`panel${index}`)}
                        sx={{ mb: 2, boxShadow: 1, border: "none" }}
                    >
                        <AccordionSummary
                            expandIcon={<AddRoundedIcon fontSize='medium' />}
                            sx={{
                                // fontFamily: secondaryFont,
                                // backgroundColor: '#fbfbfe',
                                // color: client.primary,
                                borderRadius: '4px 4px 0 0',
                                '& .MuiAccordionSummary-content': {
                                    display: 'flex',
                                    alignItems: 'center',
                                },
                            }}
                        >
                            <Typography variant="h6">{faq.question}</Typography>
                        </AccordionSummary>
                        <AccordionDetails
                            sx={{
                                backgroundColor: 'background.paper',
                                borderRadius: '0 0 8px 8px',
                                // px: 3,
                                py: 2,
                            }}
                        >
                            <Typography variant='body1'>{faq.answer}</Typography>
                            <Stack mt={2}>
                                {
                                    faq?.listItems && faq?.listItems?.map((item) => (
                                        <ListItem>{item}</ListItem>
                                    ))
                                }
                            </Stack>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </Box>
        </Container>
    );
}

export default FAQSection;
